export const STREETS_HEADER_TITLES = {
	ID: 'ID',
	STREET: 'Вулиця',
	COMMENT: 'Коментар',
	TYPE_STREET: 'Тип вулиці',
	TYPE_STREET_SHORT: 'Тип вулиці скорочено',
	CITY: 'Місто',
	CITY_SHOR_PREFIX: 'Скороч. префікс',
	CITY_PREFIX: 'Префікс',
	CREATED_AT: 'Створено',
	UPDATED_AT: 'Оновлено',
};

export const ALIASES_BY_PROVIDER_HEADER_TITLES = {
	ID: 'ID',
	STREET: 'Вулиця',
	STREET_ID: 'ID Вулиці',
	PROVIDER: 'Провайдер',
	TYPE_STREET: 'Тип вулиці',
	TYPE_STREET_SHORT: 'Тип вулиці скорочено',
	CITY: 'Місто',
	CITY_SHOR_PREFIX_CE: 'Скороч. префікс (КП)',
	CITY_PREFIX_CE: 'Префікс (КП)',
	STREET_CE: 'Вулиця (КП)',
	TYPE_STREET_CE: 'Тип вулиці (КП)',
	CITY_CE: 'Місто (КП)',
	CREATED_AT: 'Створено',
	UPDATED_AT: 'Оновлено',
};
